import * as React from 'react';

import classNames from 'classnames';

import VolumeDownSvg from 'bundles/video-player/assets/svg/VolumeDownSvg';
import VolumeOffSvg from 'bundles/video-player/assets/svg/VolumeOffSvg';
import VolumeUpSvg from 'bundles/video-player/assets/svg/VolumeUpSvg';
import ModernTooltipWrapper from 'bundles/video-player/components/ModernTooltipWrapper';

import _t from 'i18n!nls/video-player';

type Props = {
  onVolumeButtonClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  volume: number;
  muted: boolean;
};

const VolumeMenuButton = ({ onVolumeButtonClick, volume, muted }: Props) => {
  const label = _t('Volume');
  const tooltipText = muted ? _t('Unmute') : _t('Mute');

  const volumeIcon = () => {
    if (!muted && volume > 0.3) {
      return <VolumeUpSvg width={28} height={28} />;
    } else if (!muted && volume > 0 && volume <= 0.3) {
      return <VolumeDownSvg width={28} height={28} />;
    } else {
      return <VolumeOffSvg width={28} height={28} />;
    }
  };
  return (
    <ModernTooltipWrapper placement="top" message={tooltipText} keyboardShortcut="m">
      <button
        type="button"
        className={classNames('vjs-button', 'vjs-control', 'c-vjs-button')}
        aria-disabled="false"
        aria-label={tooltipText}
        onClick={onVolumeButtonClick}
      >
        <React.Fragment>{volumeIcon()}</React.Fragment>
        <span className="vjs-control-text"> {label} </span>
      </button>
    </ModernTooltipWrapper>
  );
};

export default VolumeMenuButton;
